import { AxiosPromise } from 'axios';
import { useParametro as useParametroCommon } from 'common/hooks';
import { ParametroService } from 'service';

type Props<T> = {
  id: number;
  getValue: (param?: string) => T;
  key?: any[];
};

export const useParametro = <T,>({ id, getValue, key = [] }: Props<T>) => {
  return useParametroCommon<T>({
    id,
    getValue,
    key,
    getValorParametro: codigo =>
      ParametroService.findParametro(codigo).then(
        response =>
          ({
            ...response,
            data: response.data?.valor
          } as any as AxiosPromise<string | null>)
      )
  });
};
